/**
 * resourceTagWarning模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceTagWarning = {
  // 分页
  page(params) {
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/page`,params);
  },
  // 新增
  create(params) {
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/create`,params);
  },
  // 编辑
  update(params) {
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/update`,params);
  },
  // 删除
  delete(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/delete`,param);
  },
  // 执行
  execute(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/execute`,param);
  },
  // 查询资源类型
  inquireResourceType(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/inquireResourceType`,param);
  },
  // 查询关系
  inquireRelation() {
    return $http.post(`${global.API_URL}/sme/resourceTagWarning/inquireRelation`);
  },

}

export default resourceTagWarning;



// WEBPACK FOOTER //
// ./src/api/resourceTagWarning.js